import React, { useEffect, useRef, useState } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/zuresume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(800);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Force download
  const handleDownload = async () => {
    const response = await fetch(pdf);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Mohammad_Avaan_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container fluid className="resume-section">
      <Particle />

      {/* TOP DOWNLOAD BUTTON */}
      <Row className="justify-content-center mb-4">
        <div className="col-auto">
          <Button className="download-btn" onClick={handleDownload}>
            <AiOutlineDownload /> Download Resume
          </Button>
        </div>
      </Row>

      {/* RESUME PREVIEW */}
      <Row className="justify-content-center">
        <div ref={containerRef} style={{ width: "100%", maxWidth: "850px" }}>
          <Document file={pdf}>
            <Page
              pageNumber={1}
              width={Math.min(width, 800)}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Document>
        </div>
      </Row>

      {/* BOTTOM DOWNLOAD BUTTON */}
      <Row className="justify-content-center mt-4">
        <div className="col-auto">
          <Button className="download-btn" onClick={handleDownload}>
            <AiOutlineDownload /> Download Resume
          </Button>
        </div>
      </Row>
    </Container>
  );
}

export default ResumeNew;
